import React, { useEffect, useState } from 'react';
import { ChevronDown, ChevronRight, FileWarning } from 'lucide-react';

export const ChapterSampleInspector = ({ samples = [] }) => {
  const [open, setOpen] = useState(samples[0]?.chapter_id || '');
  useEffect(() => { setOpen(samples[0]?.chapter_id || ''); }, [samples]);

  return (
    <section className="border border-border bg-card" data-testid="chapter-sample-inspector">
      <header className="border-b border-border bg-panel-header/25 px-4 py-3">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
          <FileWarning className="h-3.5 w-3.5" /> Chapter samples
        </div>
      </header>
      <div>
        {samples.length === 0 ? (
          <p className="p-4 text-xs text-muted-foreground" data-testid="chapter-samples-empty">No chapter samples are available.</p>
        ) : samples.map((sample) => {
          const isOpen = open === sample.chapter_id;
          return (
            <article key={sample.chapter_id} className="border-b border-border last:border-b-0" data-testid={`chapter-sample-${sample.chapter_id}`}>
              <button
                type="button"
                onClick={() => setOpen(isOpen ? '' : sample.chapter_id)}
                className="flex w-full items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-secondary/50"
                data-testid={`chapter-sample-toggle-${sample.chapter_id}`}
              >
                <span className="flex min-w-0 items-center gap-2">
                  {isOpen ? <ChevronDown className="h-3.5 w-3.5 shrink-0" /> : <ChevronRight className="h-3.5 w-3.5 shrink-0" />}
                  <span className="truncate text-xs font-semibold">Ch {sample.chapter_number} · {sample.title}</span>
                </span>
                <span className="font-mono-stat text-[10px] font-semibold">{sample.risk_score} · {sample.risk_level}</span>
              </button>
              {isOpen && (
                <div className="border-t border-border bg-background px-4 py-4" data-testid={`chapter-sample-content-${sample.chapter_id}`}>
                  <div className="mb-3 flex flex-wrap gap-1.5">
                    {(sample.reasons || []).map((reason) => (
                      <span key={reason} className="border border-amber-400/60 bg-amber-50 px-2 py-0.5 text-[10px] font-semibold text-amber-900">{reason}</span>
                    ))}
                  </div>
                  <blockquote className="font-serif-novel text-sm leading-7 text-foreground/90" data-testid={`chapter-excerpt-${sample.chapter_id}`}>
                    {sample.excerpt || 'No excerpt was captured.'}
                  </blockquote>
                  <div className="mt-3 font-mono-stat text-[9.5px] uppercase text-muted-foreground">{sample.words?.toLocaleString()} words</div>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
};